export interface PolicyTax {
  id: number;
  tax: number;
  additionalPrima?: number;
  primaMin?: number;
  indemnificationLimitMin?: number | null;
  indemnificationLimitMax?: number | null;
}

/** Misma fórmula que tryger-backend/src/helpers/calculatePolicyPrice.ts */
export function calculatePolicyPriceFromTax(
  tax: PolicyTax,
  indemnificationLimit: number,
  withoutTax = false,
): number {
  if (
    tax.indemnificationLimitMin &&
    tax.indemnificationLimitMin > indemnificationLimit
  ) {
    throw new Error(
      `La indemnizacion enviada es inferior a la que esta tasa puede aceptar. Tax consultada: ${tax.id}`,
    );
  }
  if (
    tax.indemnificationLimitMax &&
    tax.indemnificationLimitMax < indemnificationLimit
  ) {
    throw new Error(
      `La indemnizacion enviada es superior a la que esta tasa puede aceptar. Tax consultada: ${tax.id}`,
    );
  }

  let price: number;
  if (withoutTax) {
    price = indemnificationLimit * (tax.tax / 100) + (tax.additionalPrima ?? 0);
  } else {
    price =
      (indemnificationLimit * (tax.tax / 100) + (tax.additionalPrima ?? 0)) *
      1.16;
  }

  const total = price < (tax.primaMin ?? 0) ? (tax.primaMin ?? 0) : price;
  return parseFloat(total.toFixed(2));
}
